interface ReportDocumentHeadingProps {
  title: string;
  subtitle: string;
}

// Заглавието на отчета ВЪТРЕ в самия документ. На екран е скрито, защото
// хедърът на модала показва същия текст; при печат обаче се разпечатва само
// `.report-doc-paper` (хедърът остава извън него), а отчет без номер, дата и
// заведение е негоден документ.
export const ReportDocumentHeading = ({
  title,
  subtitle,
}: ReportDocumentHeadingProps) => (
  <div className="mb-6 hidden print:block">
    <h1 className="text-lg font-bold leading-[1.2] text-gray-900">{title}</h1>
    <p className="mt-1 text-sm text-gray-600">{subtitle}</p>
  </div>
);
